// Meta Ads navigation, in the same shape as the main app's workspaceNav.js.

const starts = (...prefixes) => (pathname) => prefixes.some((prefix) => pathname === prefix || pathname.startsWith(`${prefix}/`));

export const NAV_GROUPS = [
  {
    id: 'daily',
    items: [
      { id: 'home', label: 'Home', to: '/home', icon: 'home', match: starts('/home') },
      { id: 'campaigns', label: 'Campaigns', to: '/campaigns', icon: 'campaigns', match: starts('/campaigns') },
      { id: 'leads', label: 'Leads', to: '/leads', icon: 'leads', badge: 'new_leads', match: starts('/leads') },
    ],
  },
  {
    id: 'build',
    label: 'Build',
    items: [
      { id: 'drafts', label: 'Drafts', to: '/drafts', icon: 'drafts', badge: 'in_review', match: (p) => starts('/drafts')(p) || (starts('/create')(p) && p !== '/create') },
      { id: 'creatives', label: 'Creatives', to: '/creatives', icon: 'creatives', match: starts('/creatives') },
      { id: 'audiences', label: 'Audiences', to: '/audiences', icon: 'audiences', match: starts('/audiences') },
    ],
  },
  {
    id: 'grow',
    label: 'Grow',
    items: [
      { id: 'reports', label: 'Reports', to: '/reports', icon: 'reports', match: starts('/reports') },
      { id: 'automations', label: 'Automations', to: '/automations', icon: 'automations', badge: 'rules_on', soft: true, match: starts('/automations') },
    ],
  },
];

export const FOOTER_ITEMS = [
  { id: 'activity', label: 'Activity', to: '/activity', icon: 'activity', match: starts('/activity') },
  { id: 'settings', label: 'Settings', to: '/settings', icon: 'settings', match: starts('/settings') },
  { id: 'guide', label: 'Guide', to: '/guide', icon: 'guide', match: starts('/guide') },
];

export function activeItemId(pathname) {
  for (const group of NAV_GROUPS) {
    const found = group.items.find((item) => item.match(pathname));
    if (found) return found.id;
  }
  return FOOTER_ITEMS.find((item) => item.match(pathname))?.id || null;
}

// Product switcher tones, shared with the other Auto Appy products.
export const PRODUCT_TONES = { main: '#147DB5', whatsapp: '#1F9D57', crm: '#183F5A', ai: '#37A1D2', meta: '#1A8CCB' };
const isAi = (app) => /(^|[-_\s])ai($|[-_\s])/i.test(String(app?.key || '')) || /\bAI\b/.test(String(app?.name || ''));
const isMeta = (app) => /meta/i.test(String(app?.key || '')) || /meta ads/i.test(String(app?.name || ''));
export const productTone = (app) => PRODUCT_TONES[app?.key] || (isMeta(app) ? PRODUCT_TONES.meta : isAi(app) ? PRODUCT_TONES.ai : '#3A5264');
const MARKS = { main: 'AA', whatsapp: 'WA', crm: 'CRM' };
export function productMark(app) {
  if (MARKS[app?.key]) return MARKS[app.key];
  if (isMeta(app)) return 'ADS';
  if (isAi(app)) return 'AI';
  const rest = String(app?.name || '').replace(/^auto\s*appy\s*/i, '').trim();
  return (rest.split(/\s+/).filter(Boolean).map((part) => part[0]).join('').slice(0, 2) || 'AA').toUpperCase();
}
